function initRevealOnScroll() {
  const revealItems = document.querySelectorAll('.reveal-on-scroll');
  if (!revealItems.length) return;

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.15 }
    );
    revealItems.forEach((item) => observer.observe(item));
  } else {
    revealItems.forEach((item) => item.classList.add('is-visible'));
  }
}

function initHeroParallax() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const heroMedia = document.querySelector('[data-hero-parallax]');
  if (!heroMedia) return;

  const layers = heroMedia.querySelectorAll('[data-parallax-layer]');
  const floatingCard = heroMedia.querySelector('[data-parallax-floating]');
  if (!layers.length && !floatingCard) return;

  let mouseX = 0;
  let mouseY = 0;
  let rafId = null;

  const resetTransforms = () => {
    layers.forEach((layer) => {
      layer.style.transform = '';
    });
    if (floatingCard) {
      floatingCard.style.transform = '';
    }
  };

  const applyTransforms = () => {
    rafId = null;
    const rect = heroMedia.getBoundingClientRect();
    const centerX = rect.left + rect.width / 2;
    const centerY = rect.top + rect.height / 2;
    const offsetX = (mouseX - centerX) / rect.width;
    const offsetY = (mouseY - centerY) / rect.height;

    layers.forEach((layer) => {
      const depth = parseFloat(layer.dataset.parallaxLayer || '0.05');
      const translateX = offsetX * depth * 40;
      const translateY = offsetY * depth * 40;
      layer.style.transform = `translate3d(${translateX}px, ${translateY}px, 0)`;
    });

    if (floatingCard) {
      const translateX = offsetX * -8;
      const translateY = offsetY * -6;
      floatingCard.style.transform = `translate(-50%, 0) translate3d(${translateX}px, ${translateY}px, 0)`;
    }
  };

  const handlePointerMove = (event) => {
    if (window.innerWidth < 900) {
      resetTransforms();
      return;
    }
    mouseX = event.clientX;
    mouseY = event.clientY;
    if (!rafId) {
      rafId = requestAnimationFrame(applyTransforms);
    }
  };

  window.addEventListener('mousemove', handlePointerMove, { passive: true });
  window.addEventListener('resize', () => {
    if (window.innerWidth < 900) {
      resetTransforms();
    }
  });
}

function initCategoryCardAnimations(scope = document) {
  if (!window.gsap) return;
  const cards = scope.querySelectorAll('[data-category-card]');
  if (!cards.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        const card = entry.target;
        const media = card.querySelector('.giolippo-category-card__media img');
        const contentItems = card.querySelectorAll('.giolippo-category-card__content > *');
        const tl = window.gsap.timeline();
        tl.fromTo(
          card,
          { autoAlpha: 0, y: 24 },
          { autoAlpha: 1, y: 0, duration: 0.45, ease: 'power2.out' }
        );
        if (media) {
          tl.fromTo(
            media,
            { scale: 1.08 },
            { scale: 1, duration: 0.8, ease: 'power3.out' },
            0
          );
        }
        if (contentItems.length) {
          tl.fromTo(
            contentItems,
            { autoAlpha: 0, y: 14 },
            { autoAlpha: 1, y: 0, duration: 0.4, stagger: 0.07, ease: 'power2.out' },
            0.1
          );
        }
      });
    },
    { threshold: 0.35 }
  );

  cards.forEach((card) => {
    window.gsap.set(card, { autoAlpha: 0 });
    observer.observe(card);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initRevealOnScroll();
  initHeroParallax();
  initCategoryCardAnimations();
});

document.addEventListener('shopify:section:load', (event) => {
  initRevealOnScroll();
  initHeroParallax();
  initCategoryCardAnimations(event.target);
});
